<template>
  <div class="rule">
    <img src="../assets/rule-min.png" alt="rule" class="rule-title" />
    <div class="content">
      <div class="rules">
        <i class="circle">1</i>
        <p class="msg">抽奖活动仅限在带有雷电平台标识的游戏包内充值才能获得次数奖励。</p>
      </div>
      <div class="rules">
        <i class="circle">2</i>
        <p class="msg">对于恶意刷奖的用户，中奖资格自动作废，不予发奖。</p>
      </div>
      <div class="rules">
        <i class="circle">3</i>
        <p class="msg">雷币使用方法：在【雷电圈APP-我的-雷币】中进入充值，雷币可用于购买商城周边，以及在充值雷电官方游戏时抵扣现金。</p>
      </div>
      <div class="rules">
        <i class="circle">4</i>
        <p class="msg">雷电云手机使用方法：在【雷电圈APP】中点击下方“云手机”按钮进入即可使用，云手机适用于在手机上多开挂机。</p>
      </div>
      <div class="rules">
        <i class="circle">5</i>
        <p class="msg">活动一切解释权归雷电模拟器平台所有。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rule"
};
</script>

<style lang="scss" scoped>
.rule {
  .rule-title {
    display: block;
    margin: 0 auto;
    width: 620px;
    margin-bottom: 60px;
  }
  .content {
    padding: 0 50px 0 40px;
    width: 100%;
    box-sizing: border-box;
    .rules {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      font-size: 26px;
      color: #6e3521;
      text-align: left;
      .circle {
        flex-shrink: 0;
        font-style: normal;
        display: block;
        width: 40px;
        padding-left: 30px;
        height: 64px;
        background-image: url("../assets/star-min.png");
        background-size: 100% 100%;
        font-size: 24px;
        color: #6e3521;
        font-weight: 600;
        line-height: 45px;
        margin-top: 5px;
        margin-right: 30px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>